import React, { useState, useRef } from "react";

import { Input } from "../ui/input";
import { Textarea } from "../ui/textarea";
import { Label } from "../ui/label";

import Select from "../generic/Select";
import LocationPicker from "../generic/LocationPicker";

import AddSkills from "./AddSkills";
import AddCertification from "./AddCertification";
import AddEquipments from "../generic/AddEquipments";

const distanceOptions = [
  { value: "Upto 10 miles", label: "Upto 10 miles" },
  { value: "Upto 25 miles", label: "Upto 25 miles" },
  { value: "Upto 50 miles", label: "Upto 50 miles" },
  { value: "I'm open to travelling", label: "I'm open to travelling" },
];

const roleOptions = [
  { value: "1", label: "Director" },
  { value: "2", label: "Camera Operator" },
  { value: "3", label: "Audio Engineer" },
  { value: "4", label: "Lighting Technician" },
  { value: "5", label: "Video Editor" },
  { value: "6", label: "Stream Engineer" },
  { value: "7", label: "Production Manager" },
  { value: "8", label: "Graphics Designer" },
  { value: "9", label: "Videographer" },
  { value: "10", label: "Photographers" },
];

const skillOptions = [
  { value: "13", label: "Director" },
  { value: "12", label: "Livestream Audio" },
  { value: "2", label: "Video Event" },
  { value: "3", label: "Video Music" },
  { value: "4", label: "Video Lifestyle" },
  { value: "5", label: "Photo Portrait" },
  { value: "6", label: "Photo Product" },
  { value: "7", label: "Photo Event" },
  { value: "8", label: "Photo Lifestyle" },
  { value: "9", label: "Audio Engineer" },
  { value: "10", label: "Creative Director" },
  { value: "11", label: "Livestream Director" },
  { value: "1", label: "Video Commercial" },
  { value: "14", label: "Video Weddings" },
  { value: "15", label: "Photo Weddings" },
  { value: "16", label: "Portrait Photo" },
  { value: "17", label: "Cinematographer" },
];

const MemberForm = ({ passRef, handleSubmit, certifications, setCertifications }) => {
  const primaryRoleRef = useRef(null);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [location, setLocation] = useState(null);

  const [primaryRole, setPrimaryRole] = useState([]);
  const [yoe, setYoE] = useState("");
  const [hourlyRate, setHourlyRate] = useState("");
  const [bio, setBio] = useState("");
  const [workingDistance, setWorkingDistance] = useState("");

  const [errors, setErrors] = useState({});

  const [skills, setSkills] = useState([]);
  const [equipmentsOwned, setEquipmentsOwned] = useState([]);

  const validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };

  const onSubmit = (e) => {
    e.preventDefault();

    const newErrors = {};

    // -----------------------
    // REQUIRED VALIDATIONS
    // -----------------------
    if (!firstName.trim()) {
      newErrors.firstName = "First name is required";
    }

    if (!lastName.trim()) {
      newErrors.lastName = "Last name is required";
    }

    if (!email.trim()) {
      newErrors.email = "Email is required";
    } else if (!validateEmail(email)) {
      newErrors.email = "Please enter a valid email address";
    }

    if (!primaryRole || primaryRole.length === 0) {
      newErrors.primaryRole = "Please select primary role";
    }

    setErrors(newErrors);

    // Stop submission if there are errors
    // if (Object.keys(newErrors).length > 0) {
    //     // Scroll to the top of the form so the user sees the errors
    //     passRef.current?.scrollIntoView({ behavior: 'smooth' });
    //     return;
    // }
    if (Object.keys(newErrors).length > 0) {
  if (newErrors.primaryRole && primaryRoleRef.current) {
    primaryRoleRef.current.scrollIntoView({
      behavior: "smooth",
      block: "center",
    });
  }
  return;
}


    const formData = {
      first_name: firstName,
      last_name: lastName,
      email,
      phone_number: phoneNumber,
      location: location ? JSON.stringify(location) : "",
      bio,
      primary_role: primaryRole,
      years_of_experience: yoe,
      hourly_rate: hourlyRate,
      working_distance: workingDistance,
      skills: JSON.stringify(skills),
      certifications,
      equipment_ownership: equipmentsOwned,
    };

    handleSubmit(formData);
  };

  return (
    <form ref={passRef} onSubmit={onSubmit} className="flex flex-col gap-6">
      <div className="border border-border bg-card rounded-2xl items-start p-6">
        <div className="flex flex-col gap-1.5 mb-6">
          <div className="text-foreground text-2xl font-semibold leading-6">Personal Information</div>
        </div>

        <div className="flex-1 flex flex-col items-start gap-4">
          <div className="flex gap-2 w-full">
            {/* FIRST NAME (REQUIRED) */}
            <div className="flex flex-col items-start gap-2 w-full">
              <Label className="label text-foreground text-sm font-bold leading-4" htmlFor="first_name">
                First Name <span className="text-red-500">*</span>
              </Label>
              <Input
                type="text"
                name="first_name"
                id="first_name"
                placeholder="Jane"
                onChange={(e) => {
                    setFirstName(e.target.value);
                    if (errors.firstName) setErrors(prev => ({...prev, firstName: null}));
                }}
                value={firstName}
                error={!!errors.firstName}
              />
              {errors.firstName && <p className="text-red-500 text-xs mt-1">{errors.firstName}</p>}
            </div>

            {/* LAST NAME (REQUIRED) */}
            <div className="flex flex-col items-start gap-2 w-full">
              <Label className="label text-foreground text-sm font-bold leading-4" htmlFor="last_name">
                Last Name <span className="text-red-500">*</span>
              </Label>
              <Input
                type="text"
                name="last_name"
                id="last_name"
                placeholder="Doe"
                onChange={(e) => {
                    setLastName(e.target.value);
                    if (errors.lastName) setErrors(prev => ({...prev, lastName: null}));
                }}
                value={lastName}
                error={!!errors.lastName}
              />
              {errors.lastName && <p className="text-red-500 text-xs mt-1">{errors.lastName}</p>}
            </div>
          </div>

          {/* EMAIL (REQUIRED) */}
          <div className="flex gap-2 w-full">
            <div className="w-full flex flex-col gap-2">
              <Label className="label text-foreground text-sm font-bold leading-4" htmlFor="email">
                Contact Email <span className="text-red-500">*</span>
              </Label>
              <Input
                type="email"
                name="email"
                id="email"
                placeholder="contact@company.com"
                onChange={(e) => {
                    setEmail(e.target.value);
                    if (errors.email) setErrors(prev => ({...prev, email: null}));
                }}
                value={email}
                error={!!errors.email}
              />
              {errors.email && <p className="text-red-500 text-xs mt-1">{errors.email}</p>}
            </div>

            <div className="w-full flex flex-col gap-2">
              <Label className="label text-foreground text-sm font-bold leading-4" htmlFor="phone_number">Contact Phone</Label>
              <div className="relative w-full">
                <div className="absolute inset-y-0 left-3 flex items-center gap-2 pointer-events-none">
                  <img
                    src="https://flagcdn.com/us.svg"
                    alt="USA flag"
                    className="w-5 h-5 rounded-full object-cover"
                  />
                  <span className="text-sm text-muted-foreground">+1</span>
                </div>
                <Input
                  type="tel"
                  name="phone_number"
                  id="phone_number"
                  className="py-2 pl-16 pr-3"
                  placeholder="Enter phone number"
                  onChange={(e) => setPhoneNumber(e.target.value)}
                  value={phoneNumber}
                />
              </div>
            </div>
          </div>

          <div className="flex flex-col items-start gap-2 w-full">
            <Label className="label text-foreground text-sm font-bold leading-4" htmlFor="location">Location</Label>
            <LocationPicker
              value={location}
              onChange={setLocation}
              placeholder="Click to select venue location on map"
            />
          </div>

          <div className="flex flex-col items-start gap-2 w-full">
            <Label className="label text-foreground text-sm font-bold leading-4" htmlFor="working_distance">Working Distance</Label>
            <Select
              id="working_distance"
              options={distanceOptions}
              placeholder="Select working distance"
              value={workingDistance}
              onChange={setWorkingDistance}
            />
          </div>
        </div>
      </div>

      {/* PROFESSIONAL DETAILS */}
      <div className="border border-border bg-card rounded-2xl items-start p-6">
        <div className="text-foreground text-2xl font-bold leading-6 mb-4">Professional Details</div>

        <div className="flex gap-4 w-full mb-4">
          {/* <div className="w-full flex flex-col gap-2">
            <Label className="label text-foreground text-sm font-bold leading-4" htmlFor="primary_role">Primary Role</Label>
            <Select id="primary_role" options={roleOptions} placeholder="Select Role" onChange={setPrimaryRole} />
          </div> */}
          <div ref={primaryRoleRef} className="w-full flex flex-col gap-2">
            <Label
              className="label text-foreground text-sm font-bold leading-4"
              htmlFor="primary_role"
            >
              Primary Role <span className="text-red-500">*</span>
            </Label>

            <Select
              id="primary_role"
              options={roleOptions}
              placeholder="Select Role"
              value={primaryRole}
              onChange={(value) => {
                setPrimaryRole(value);
                if (errors.primaryRole) {
                  setErrors((prev) => ({ ...prev, primaryRole: null }));
                }
              }}
            />

            {errors.primaryRole && (
              <p className="text-red-500 text-xs mt-1">
                {errors.primaryRole}
              </p>
            )}
          </div>

          <div className="w-full flex flex-col gap-2">
            <Label className="label text-foreground text-sm font-bold leading-4" htmlFor="years_of_experience">Years of Experience</Label>
            <Input
              type="number"
              name="years_of_experience"
              id="years_of_experience"
              placeholder="Enter years of experience"
              className="h-12"
              onChange={(e) => setYoE(e.target.value)}
              value={yoe}
            />
          </div>
        </div>

        <div className="w-full flex flex-col gap-2 mb-4">
          <Label className="label text-foreground text-sm font-bold leading-4" htmlFor="hourly_rate">Hourly Rate ($)</Label>
          <Input
            type="text"
            name="hourly_rate"
            id="hourly_rate"
            placeholder="Enter hourly rate"
            onChange={(e) => setHourlyRate(e.target.value)}
            value={hourlyRate}
          />
        </div>

        <div className="flex flex-col gap-2 w-full">
          <Label className="label text-foreground text-sm font-bold leading-4" htmlFor="bio">Description</Label>
          <Textarea
            name="bio"
            id="bio"
            placeholder="Brief description of expertise and background..."
            onChange={(e) => setBio(e.target.value)}
            value={bio}
          />
        </div>
      </div>

      {/* SKILLS */}
      <div className="border border-border bg-card rounded-2xl items-start p-6">
        <p className="text-foreground text-sm font-bold mb-2">Skills</p>
        <AddSkills value={skills} onChange={setSkills} options={skillOptions} />
      </div>

      <AddCertification value={certifications} onChange={setCertifications} />

      {/* EQUIPMENT */}
      <div className="border border-border bg-card rounded-2xl items-start p-6 overflow-visible">
        <div className="flex flex-col gap-1.5 mb-6">
          <div className="text-foreground text-2xl font-semibold leading-6">Equipment Ownership (Optional)</div>
          <div className="text-muted-foreground text-sm font-normal leading-5">
            List any professional equipment this crew member owns and can bring to projects.
          </div>
        </div>
        <AddEquipments placeholder={"Add equipment"} value={equipmentsOwned} onChange={setEquipmentsOwned} />
      </div>
    </form>
  );
};

export default MemberForm;
